import { ANSARIUM_LEGAL } from './ansarium-legal-documents'

/**
 * Короткие ключи для форм и футера. URL задаются в `ansarium-legal-documents.ts`.
 */
export const LEGAL_LINKS = {
    terms: ANSARIUM_LEGAL.termsOfUse.url,
    privacy: ANSARIUM_LEGAL.privacyPolicy.url,
    cookies: ANSARIUM_LEGAL.cookiePolicy.url,
    personalData: ANSARIUM_LEGAL.consentPersonalData.url,
} as const

export { ANSARIUM_LEGAL } from './ansarium-legal-documents'
